var $8045cf930ef745aa$exports = {};
$8045cf930ef745aa$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Renk Se\xE7ici",
  "colorSwatch": "renk \xF6rne\u011Fi",
  "transparent": "saydam",
  "twoDimensionalSlider": "2D s\xFCrg\xFC"
};
export { $8045cf930ef745aa$exports as default };